import React, { useState, useEffect } from 'react';
import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    CircularProgress,
    FormHelperText,
    InputAdornment,
} from '@mui/material';
import { RouterOutlined } from '@mui/icons-material';
import { nasService } from '../../services/nasService';
import { Nas } from '../../types';

interface NasSelectProps {
    value?: number | null;
    onChange: (value: number | null) => void;
    label?: string;
    size?: 'small' | 'medium';
    error?: boolean;
    helperText?: string;
    required?: boolean;
    disabled?: boolean;
    fullWidth?: boolean;
}

const NasSelect: React.FC<NasSelectProps> = ({
    value,
    onChange,
    label = 'Equipamento NAS',
    size = 'small',
    error = false,
    helperText,
    required = false,
    disabled = false,
    fullWidth = true,
}) => {
    const [nasList, setNasList] = useState<Nas[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const loadNas = async () => {
            try {
                setLoading(true);
                const data = await nasService.getAll();
                setNasList(data || []);
            } catch (err) {
                console.error('Erro ao carregar NAS:', err);
            } finally {
                setLoading(false);
            }
        };
        loadNas();
    }, []);

    const handleChange = (val: any) => {
        if (val === '' || val === null || val === undefined) {
            onChange(null);
        } else {
            onChange(Number(val));
        }
    };

    const currentValue = value ?? '';

    return (
        <FormControl fullWidth={fullWidth} size={size} error={error} disabled={disabled}>
            <InputLabel required={required}>{label}</InputLabel>
            <Select
                value={currentValue}
                label={label}
                onChange={(e) => handleChange(e.target.value)}
                startAdornment={
                    <InputAdornment position="start">
                        <RouterOutlined fontSize="small" />
                    </InputAdornment>
                }
            >
                {!required && (
                    <MenuItem value="">
                        <em>Nenhum</em>
                    </MenuItem>
                )}
                {loading ? (
                    <MenuItem disabled>
                        <CircularProgress size={20} sx={{ mr: 1 }} />
                        Carregando...
                    </MenuItem>
                ) : (
                    nasList.map((nas) => (
                        <MenuItem key={nas.id} value={nas.id}>
                            {nas.shortname ? `${nas.shortname} (${nas.nasname})` : nas.nasname}
                        </MenuItem>
                    ))
                )}
            </Select>
            {helperText && <FormHelperText>{helperText}</FormHelperText>}
        </FormControl>
    );
};

export default NasSelect;
